import React from 'react';
export const TopBar = () => {
  return <header className="w-full flex flex-col items-center pt-12 pb-8 px-4 z-10 relative" data-id="element-20">
      <p className="text-white uppercase tracking-widest text-xs mb-4 font-light" data-id="element-21">
        Seguinos en Instagram
      </p>
      <div className="flex items-center gap-4 mb-8" data-id="element-22">
        <a href="https://instagram.com/nicoquarone" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Nico Quarone" className="text-we-gold text-sm hover:text-white transition-colors duration-300" data-id="element-23">
          @nicoquarone
        </a>
        <span className="text-we-gold text-xs opacity-50" data-id="element-24">•</span>
        <a href="https://instagram.com/wealthengine.ar" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Wealth Engine" className="text-we-gold text-sm hover:text-white transition-colors duration-300" data-id="element-25">
          @wealthengine.ar
        </a>
      </div>
      <div className="w-4/5 max-w-md h-px bg-we-gold opacity-40" data-id="element-26"></div>
    </header>;
};